import {Observable} from 'rxjs/Observable';
import * as ResourceApi from 'api/resources';
import {receivedLocationFile, Types, uploadedLocationsAction} from "./actions";
import {extractMasterForBreak, extractResourceIdsWithPath} from "../../utils/DBUtils";
import {filterOptionsFactory, sortOptionsFactory} from "../../viewOptions/factories";
import FilterOperator from "../../classes/FilterOperators";
import {saveResourceChangelistSuccess} from "../../resources/actions";

const uploadStoreLocationsEpic = (action$, store) => action$.ofType(Types.UPLOAD_LOCATIONS)
    .mergeMap((action) => {
            let storeFinderImport = store.getState().storeFinderImport;
            let master = extractMasterForBreak(store.getState().resources.resources, storeFinderImport.brk);
            let resourceIds = extractResourceIdsWithPath(master, storeFinderImport.brk, storeFinderImport.resourcePath);
            let breakId = resourceIds[1].id;
            let stepId = resourceIds[0].id;
            console.log('upload', resourceIds);
            return ResourceApi.upload(
                ResourceApi.Types.StoreLocationFile,
                action.file,
                {
                    breakId: breakId,
                    stepId: stepId,
                },
                resourceIds
            )
                .map(({response: {object}}) => {
                    return uploadedLocationsAction(object);
                })
                .catch(err => Observable.of({type: "ERROR", error: err}));
        }
    );

const getLocationFileEpic = (action$) => action$.ofType(Types.GET_LOCATION_FILE)
    .mergeMap(action => {
        let sorts = sortOptionsFactory();
        let filters = filterOptionsFactory({
            filters: [
                {
                    field: 'params.stepId',
                    value: action.stepId
                },
                {
                    field: 'params.breakId',
                    value: action.breakId
                },
                {
                    field: 'status',
                    operator: FilterOperator.NotEqual,
                    value: 'COMPLETE'
                }
            ]
        });
        return ResourceApi.query(ResourceApi.Types.DailybreakJob, sorts, filters)
            .map(({response: {object}}) => {
                return receivedLocationFile(object);
            })
            .catch(err => Observable.of({type: "ERROR", error: err}));
    });

const removeLocationFileEpic = (action$, store) => action$.ofType(Types.REMOVE_LOCATION_FILE)
    .mergeMap(action => {
        let master = extractMasterForBreak(store.getState().resources.resources, action.rootResource);
        let ids = extractResourceIdsWithPath(master, action.rootResource, action.resourcePath);
        return ResourceApi.deleteResource(ResourceApi.Types.StoreLocationFile, action.file.id, ids, {})
            .mergeMap((response) => {
                let changelist = {
                    client: "",
                    storeLocationFileId: null,
                    storeLocationFile: null
                };

                return Observable.of(
                    saveResourceChangelistSuccess(ResourceApi.Types.StoreFinderStep, ids[1].id, changelist, ids[1].id, action.resourcePath)
                );
            })
            .catch(err => Observable.of({type: "ERROR", error: err}));
    });

export default [
    uploadStoreLocationsEpic,
    getLocationFileEpic,
    removeLocationFileEpic
]



// WEBPACK FOOTER //
// ./public/pages/StoreFinderImport/epics.js